<template>
  <div class="pc-language-switcher" :class="{'light': theme === 'light'}">
    <span :class="{'active': isDefault}" class="pc-lang-item" @click="updateLanguage('uk')">Укр</span>
    <div class="pc-switch-body" @click="toggleLang">
      <div :class="{'ua': isDefault, 'en': !isDefault}" class="pc-switcher"></div>
    </div>
    <span :class="{'active': !isDefault}" class="pc-lang-item" @click="updateLanguage('en')">Eng</span>
  </div>
</template>

<script>
import {api} from '@/api/api'

export default {
  name: 'PcLanguageSwitcher',
  props: {
    theme: {
      type: String,
      default: ''
    }
  },
  computed: {
    isDefault() {
      return this.$root.$i18n.locale === 'uk'
    }
  },

  methods: {
    updateLanguage(code) {
      if(code && code !== this.$root.$i18n.locale) {
        this.$router.replace({params: {lang: code},query: this.$route.query})
        this.$root.$i18n.locale = code
      } else {
        code = this.$root.$i18n.locale
      }
      const formData = new FormData()
      formData.append('interface_language', code)
      api.auth.updateUserInfo(formData)
    },
    toggleLang() {
      const lang = this.$root.$i18n.locale === 'uk'? 'en' : 'uk'
      this.updateLanguage(lang)
    }
  }
}
</script>


